/** Release the caller on cancellation/deadline, but keep ownership of late resources. */
export function runVideoOperation<T>(options: {
  start: () => Promise<T>;
  signal?: AbortSignal;
  timeoutMs?: number;
  disposeLate?: (value: T) => void | Promise<void>;
}): Promise<T> {
  return new Promise((resolve, reject) => {
    let settled = false;
    let timer: ReturnType<typeof setTimeout> | undefined;
    const finish = (ok: boolean, value?: T, error?: unknown) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      options.signal?.removeEventListener("abort", abort);
      if (ok) resolve(value as T);
      else reject(error);
    };
    const abort = () => finish(false, undefined, new DOMException("Camera cancelled", "AbortError"));
    if (options.signal?.aborted) { abort(); return; }
    options.signal?.addEventListener("abort", abort, { once: true });
    timer = setTimeout(() => finish(false, undefined, new Error("攝影機準備逾時，請重試去背。")), options.timeoutMs ?? 15_000);
    let pending: Promise<T>;
    try { pending = options.start(); }
    catch (error) { finish(false, undefined, error); return; }
    void pending.then((value) => {
      if (!settled) finish(true, value);
      else void Promise.resolve().then(() => options.disposeLate?.(value)).catch(() => undefined);
    }, (error: unknown) => finish(false, undefined, error));
  });
}
